import React from 'react';
import { Box, styled, Typography } from '@mui/material';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';
import { EligibilityCheckSVG } from 'components/SignUpForm/Steps/TransitionSteps/EligibilityCheckSVG';

const StyledBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
  minHeight: '500px',
}));

export const SignUpHelpDialogConfirmation = () => {
  const { theme } = useThemeUtils();
  const { translation } = useTranslationContext();

  return (
    <StyledBox>
      <EligibilityCheckSVG
        brandPrimary={theme.palette.primary.main}
        brandSecondary={theme.palette.secondary.main}
        brandPrimaryBackground={theme.palette.brandBackgroundPrimary.main}
        brandSecondaryBackground={theme.palette.brandBackgroundSecondary.main}
        brandShade1={theme.palette.brandShade1.main}
        brandShade2={theme.palette.brandShade2.main}
        brandTint={theme.palette.brandTint.main}
      />
      <Typography variant="body1" color="grey.800" textAlign="center">
        {translation('information_has_been_submitted')} {translation('we_will_be_reaching_out')}
      </Typography>
    </StyledBox>
  );
};
